


















































































import { AdminService } from '../../biz/remote/AdminService';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dayjs } from '../../../src_server/common/momentExtends';
import { AnalyticsDTO } from '../../../src_server/entity/dto/AnalyticsDTO';
import { Sorter } from '../../utils/Sorter';
import SortTh from '../../components/atoms/SortTh.vue';

@Component({ components: { SortTh } })
export default class AnalyticsPage extends Vue {
  private rows: AnalyticsDTO[] = [];
  private year = 0;

  get summary() {
    return this.rows.reduce((pre, cur) => {
      pre.ym = cur.ym.substring(0, 4);
      pre.increaseStudent += cur.increaseStudent;
      pre.increaseTeacher += cur.increaseTeacher;
      pre.res_count += cur.res_count;
      pre.com_count += cur.com_count;
      pre.done_count += cur.done_count;
      pre.del_count += cur.del_count;
      pre.tra_count += cur.tra_count;
      pre.application_count += cur.application_count;
      return pre;
    }, new AnalyticsDTO());
  }

  async sortBy(up: boolean, target: string) {
    console.log(target, up);
    this.rows = this.rows.sort(Sorter.compareByPath(target, up));
  }

  get finalcialYear() {
    const month = dayjs().get('month');
    const year = dayjs().get('year');
    if (month < 4) {
      return year - 1;
    } else {
      return year;
    }
  }

  @Watch('year')
  async loading() {
    const biz = new AdminService();
    const date = dayjs(`${this.year}-04-01 00:00:00`).toDate();
    const result = await biz.getAnaliticsData(date);
    this.rows = result.data;
  }

  async created() {
    this.year = this.finalcialYear;
    this.loading();
  }
}
